import { Chart, Legend, LineElement, PointElement, RadarController, RadialLinearScale, Title, Tooltip, } from 'chart.js';
import React from 'react';
import { Radar } from 'react-chartjs-2';
import { chartjsPluginWindRose } from './WindRose.plugin';
import { chartjsPluginRadialArrow2 } from './arrow2';
Chart.register(RadarController, RadialLinearScale, PointElement, LineElement, Title, Legend, Tooltip);
const labels = [
    'C',
    '15°',
    '30°',
    'СВ',
    '60°',
    '75°',
    'В',
    '105°',
    '120°',
    'ЮВ',
    '150°',
    '165°',
    'Ю',
    '195°',
    '210°',
    'ЮЗ',
    '240°',
    '255°',
    'З',
    '285°',
    '300°',
    'СЗ',
    '330°',
    '345°',
];
function getOptions(title, arrowAngle, arrowColor = 'red', showLegend = false, showTicks = true, formatter, showZero = true, zeroValue) {
    return {
        elements: {
            line: {
                tension: 0.2,
            }
        },
        plugins: {
            windRose: {
                zero: {
                    display: showZero,
                    value: zeroValue,
                },
                formatter,
            },
            radialArrow2: {
                angle: arrowAngle,
                color: arrowColor,
            },
            legend: {
                display: showLegend,
            },
            tooltip: {
                enabled: true,
            },
            title: {
                display: true,
                text: title,
            },
        },
        scales: {
            r: {
                grid: {
                    circular: true,
                },
                ticks: {
                    display: showTicks,
                    callback: formatter,
                },
                pointLabels: {
                    font: {
                        size: ({ index }) => {
                            if (index % 3) {
                                return 10;
                            }
                            return 14;
                        },
                    },
                },
                beginAtZero: true,
            },
        },
    };
}
function getDatasets(datasets, formatter) {
    const newDatasets = [];
    datasets.forEach((dataset, index) => {
        let newData = [];
        if (index === 0) {
            newData = dataset.data;
        }
        else {
            const prevDataset = newDatasets[index - 1];
            newData = dataset.data?.map((value, index) => {
                const prevValue = prevDataset.data[index];
                return value + prevValue;
            });
        }
        const newDataset = {
            ...dataset,
            data: newData,
            // @ts-ignore
            tooltip: {
                callbacks: {
                    // @ts-ignore
                    label(context) {
                        const datasetIndex = context.datasetIndex;
                        const dataIndex = context.dataIndex;
                        const format = formatter || (value => value.toString());
                        const parsed = context.raw;
                        let textValue = '';
                        const dataset = datasets[datasetIndex];
                        const value = dataset.data[dataIndex];
                        textValue = format(value);
                        if (datasetIndex > 0) {
                            textValue += ` (${format(parsed)})`;
                        }
                        return `${dataset.label}: ${textValue}`;
                    }
                }
            }
        };
        newDatasets.push(newDataset);
    });
    return newDatasets;
}
const plugins = [chartjsPluginRadialArrow2, chartjsPluginWindRose];
const defaultTitle = 'Роза ветров';
export function WindRose2({ title = defaultTitle, datasets, arrowAngle, arrowColor, showLegend, showTicks, formatter, showZero, zeroValue }) {
    const chartData = React.useMemo(() => ({
        labels,
        datasets: getDatasets(datasets, formatter)
    }), [datasets]);
    const options = React.useMemo(() => getOptions(title, arrowAngle, arrowColor, showLegend, showTicks, formatter, showZero, zeroValue), [title, arrowAngle, arrowColor, showLegend, showTicks, formatter, showZero, zeroValue]);
    return (React.createElement(Radar, { data: chartData, options: options, plugins: plugins }));
}
//# sourceMappingURL=WindRose2.js.map
